import { Component, HostListener } from '@angular/core';
import { TuiRootModule, TuiHostedDropdownModule } from '@taiga-ui/core';
import { NgIf } from '@angular/common';
import { NgFor } from '@angular/common';
import {
  adminSidebarData,
  memberSidebarData,
  ROLE_DEFAULT_ROUTE,
  staffSidebarData,
} from './sidebar-data';
import { RouterModule } from '@angular/router';
import { TuiSvgModule } from '@taiga-ui/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NgClass } from '@angular/common';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { AuthService } from '../../modules/auth/services/auth.service';
import { UserService } from '../../core/services/user.service';
import { SETTINGS } from '../../core/config/common.settings';

@Component({
  selector: 'app-side-bar',
  standalone: true,
  imports: [
    TuiHostedDropdownModule,
    TuiRootModule,
    NgIf,
    NgFor,
    RouterModule,
    TuiSvgModule,
    NgClass,
  ],
  providers: [AuthService, UserService],
  templateUrl: './side-bar.component.html',
  styleUrl: './side-bar.component.scss',
  animations: [
    trigger('slideInOut', [
      state('void', style({ height: '0', opacity: '0' })),
      state('*', style({ height: '*', opacity: '1' })),
      transition('void <=> *', animate('300ms ease-in-out')),
    ]),
  ],
})
export class SideBarComponent {
  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService
  ) {}

  collapsed = false;
  SidebarData: any;
  expandedItem: any;
  user: any;

  ngOnInit(): void {
    this.checkScreenWidth();
    this.user = this.authService.getLoggedInUser();
    // Set Sidebar based on role
    switch (this.user.role) {
      case SETTINGS.USERS.ADMIN:
      case SETTINGS.USERS.SUPER_ADMIN:
      case SETTINGS.USERS.SUPPORT:
        this.SidebarData = adminSidebarData;
        break;
      case SETTINGS.USERS.STAFF:
        this.SidebarData = staffSidebarData;
        break;
      case SETTINGS.USERS.MEMBER:
        this.SidebarData = memberSidebarData;
        break;
    }
    const defaultRoute = ROLE_DEFAULT_ROUTE[this.user.role];
    if (defaultRoute) {
      this.router.navigate([defaultRoute]);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenWidth();
  }

  private checkScreenWidth(): void {
    this.collapsed = window.innerWidth <= 768; // Adjust the breakpoint as needed
  }

  toggleSidebar(): void {
    this.collapsed = !this.collapsed;
  }

  toggleSubMenu(item: any): void {
    if (this.collapsed) {
      this.collapsed = false;
    }
    this.expandedItem = this.expandedItem === item ? null : item;
  }

  // isSubMenuExpanded(item: any): boolean {
  //   return this.expandedItem === item;
  // }

  isSubMenuExpanded(item: any): boolean {
    const isItemExpanded = this.expandedItem === item;
    const isProfileActive =
      this.user.userType === SETTINGS.USERS.MEMBER &&
      item.routerLink === '/member/profile';
    const isUsersActive =
      this.user.userType === SETTINGS.USERS.ADMIN &&
      (item.routerLink === '/admin/users' ||
        item.routerLink === '/admin/users/add-edit' ||
        (item.subMenu &&
          item.subMenu.some((subItem: any) =>
            this.router.isActive(subItem.routerLink, true)
          )));

    return isItemExpanded || isProfileActive || isUsersActive;
  }

  checkPermission(data: any): boolean {
    if (data === 'Users' && this.user.role === 'USER') {
      return false;
    } else if (data === 'Dashboard') {
      return false;
    } else {
      return true;
    }
  }

  closeBarMobile(): void {
    if (window.matchMedia('(max-width: 768px)').matches) {
      this.toggleSidebar();
    }
  }

  async logout(): Promise<any> {
    this.authService.logout();
  }
}
